import styled from "styled-components";
import transition from "../../styles/transition";

export const Container = styled.div<{
  backface?: boolean;
}>`
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;

  ${({ backface }) =>
    backface &&
    `
    position: absolute;
    top: 0;
    left: 0;
    transform: rotateY(-180deg);
  `}
`;

export const Wrapper = styled.div<{
  showGrade?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  cursor: default;

  ${({ showGrade }) =>
    showGrade &&
    `
    ${transition.slow}

    transform-origin: 50% 50%;
    transform: perspective(600px);
    transform-style: preserve-3d;
  `}
`;

export const WrapperHover = styled.div<{
  width: string;
  height: string;
  showGrade?: boolean;
}>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  flex-shrink: 0;

  ${({ showGrade }) =>
    showGrade &&
    `
    &:hover ${Wrapper} {
      transform: perspective(600px) rotateY(180deg);
    }
  `}
`;

export const Grade = styled.div<{
  color: string;
}>`
  color: ${(props) => props.color};
  border: 6px solid ${(props) => props.color};
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  font-size: 60px;
  font-weight: 600;
  line-height: 1em;

  span {
    font-size: 14px;
    font-weight: 600;
    color: #647693;
    line-height: 2.4em;
  }
`;
